<template>
  <div class="item">
    <div class="item-head">
      <div class="item-head_name">
        <span v-if="substance.doc_type" class="tag">Substance active</span>
        <!-- <status-chip v-if="substance.status.class" :status="substance.status"></status-chip> -->
        <router-link
          v-if="authenticated && hasActiveSubscription"
          :to="{ name: routeNameToDetail, params: { id: substance.id } }"
        >
          {{ substance.name }}
        </router-link>
        <div v-else>{{ substance.name }}</div>
        <span :class="{ 'alert-bell': favorite && item.alert }"></span>
      </div>
      <span v-if="authenticated && hasActiveSubscription" class="item-head_fav">
        <button
          v-if="favoriteSubstances.includes(castedId)"
          @click="removeFavorite('substances', castedId)"
          class="btn-fav btn-fav--faved"
        ></button>
        <button
          v-else
          @click="addFavorite('substances', castedId)"
          class="btn-fav btn-fav"
        ></button>
      </span>
    </div>

    <div
      v-if="!mobile"
      class="item-content format-substance"
      :class="authenticated && hasActiveSubscription ? '' : 'blur'"
    >
      <div v-if="substance.types.length" class="item-type flex">
        <div
          v-if="substance.status.class"
          class="mt-0.25 flex justify-center items-center"
        >
          <status-chip
            v-if="substance.status.class"
            :status="substance.status"
          ></status-chip>
          <status-type :types="substance.types" :status="substance.status">
          </status-type>
        </div>
        <div v-else>
          <status-type :types="substance.types" :status="substance.status">
          </status-type>
        </div>
      </div>
      <div v-if="substance.cas_number" class="item-cas">
        <span class="item-label">Numéro CAS : </span>
        <span class="item-text">{{ substance.cas_number }}</span>
      </div>
      <div v-if="substance.code_rac.length" class="item-xrac">
        <div v-for="code_rac in substance.code_rac" :key="code_rac._id">
          <span class="item-label">{{ code_rac.rac_type }} : </span>
          <span class="item-text">{{ code_rac.code }}</span>
        </div>
      </div>
      <div v-if="substance.family" class="item-familleChimique">
        <span class="item-label">Famille chimique : </span>
        <span class="item-text">{{ item.family }}</span>
      </div>
      <div v-if="substance.classifications.length" class="item-class">
        <span class="item-label">Classification : </span>
        <span class="item-text">
          {{ substance.classifications.join(", ") }}
        </span>
      </div>
      <div v-if="substance.principal_activity" class="item-activity">
        <span class="item-label">Activité : </span>
        <span class="item-text">{{ substance.principal_activity }}</span>
      </div>
      <div
        class="item-culture"
        v-if="substance.cultivations && substance.cultivations.length"
      >
        <span class="item-label">Culture : </span>
        <span class="item-text">
          <span>[...]</span>
          <span v-html="substance.cultivations.join(', ')"></span>
          <span> [...]</span>
        </span>
      </div>
      <div
        class="item-cible"
        v-if="substance.targets && substance.targets.length"
      >
        <span class="item-label">Cible : </span>
        <span class="item-text">
          <span>[...]</span>
          <span v-html="substance.targets.join(', ')"></span>
          <span> [...]</span>
        </span>
      </div>
    </div>
    <div v-else class="item-content format-substance">
      <div v-if="substance.types.length">
        <span class="item-text">
          {{ substance.types.map((type) => type.name).join(", ") }}
        </span>
      </div>
    </div>
    <div v-if="favorite" class="last-update">
      Données au :
      {{ substance.last_phytcom_update }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StatusChip from "@/components/StatusChip";
import StatusType from "@/components/StatusType";
import FavoriteMixin from "@/mixins/FavoriteMixin.js";
import moment from "moment";

export default {
  name: "SubstancesListingRow",
  components: { StatusChip, StatusType },
  mixins: [FavoriteMixin],

  props: {
    item: Object,
    mobile: Boolean,
    routeNameToDetail: {
      type: String,
      default: "substanceIdentity",
    },
    favorite: Boolean,
  },

  computed: {
    ...mapState("authent", {
      favoriteSubstances: (state) => state.user?.favorite_substances || [],
    }),
    substance() {
      return this.favorite ? this.item.substance : this.item;
    },
    castedId() {
      return Number(this.substance.id);
    },
    authenticated() {
      return this.$store.getters["authent/isAuthenticated"];
    },
    hasActiveSubscription() {
      return this.$store.getters["authent/hasActiveSubscription"];
    },
  },

  methods: {
    hasBeenUpdated() {
      return moment(this.substance.last_update, "DD/MM/YYYY").isAfter(
        this.item?.last_seen
      );
    },
    format_date(date) {
      moment().locale("fr");
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>
